// extracted by mini-css-extract-plugin
export default {"title":"FaqBox_title__UuRFN","resp":"FaqBox_resp__DaX1y"};